module.exports = __webpack_public_path__ + "static/media/mobile-icons-buttons-pagination-right-arrow-default.7ddbf0f1.svg";